import useLanguages from '#hooks/use-languages.js';
import Button from '#lib/components/button.jsx';
import Dialog from '#lib/components/dialog.jsx';
import useDebounce from '#lib/hooks/use-debounce.js';
import Combobox from '#lib/components/combobox';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '#src/index.jsx';

export default function TranslationPanel(props) {
    const { isOpen, onClose, handleClick } = props;

    const { getLanguage } = useContext(UserContext);
    const lang = getLanguage();

    const [selectedLanguage, setSelectedLanguage] = useState(null); // selected combobox language
    const [languages, setLanguages] = useState([]); // laguages combobox options
    const [languageQuery, setLanguageQuery] = useState(''); //  query combobox styring
    const search = useDebounce(languageQuery, 300); // request string for combobox call

    const { languages: data, isSuccess, queryLanguages } = useLanguages(lang);

    const handleClose = () => {
        setLanguageQuery('');
        setSelectedLanguage(null);
        onClose();
    };

    const handleTranslate = () => {
        if (!confirm(_t.edit.translation.translationConfirm())) return;
        onClose();
        handleClick(selectedLanguage.id);
    };

    useEffect(() => {
        queryLanguages(search);
    }, [search]);

    useEffect(() => {
        if (isSuccess) setLanguages(data);
    }, [data, isSuccess]);

    return (
        <Dialog isOpen={isOpen} onClose={handleClose}>
            <Dialog.Panel className="flex flex-col items-end gap-4 m-10 min-w-[300px] w-full max-w-[500px] max-h-[700px]">
                <div className="w-full pr-4">
                    <Dialog.CloseButton />
                    <p className="text-2xl">{_t.edit.translation.translationTitle()}</p>
                </div>
                <div className="w-full flex items-center gap-2">
                    <p className="text-sm text-neutral-700">{_t.edit.translation.translationDescription()}</p>
                </div>

                <Combobox.Full
                    inPortal={false}
                    query={selectedLanguage?.name ?? languageQuery}
                    onQueryChange={(query) => {
                        setSelectedLanguage(null);
                        setLanguageQuery(query);
                    }}
                    onInputFocus={(e) => {
                        setLanguageQuery(e.target.value);
                    }}
                    onChange={(value) => {
                        setSelectedLanguage(value);
                    }}
                    displayValue={(opt) => {
                        return opt.name;
                    }}
                    placeholder={_t.edit.translation.translationPlaceholder()}
                    options={languages ?? []}
                    filterFn={() => true}
                    nullable={true}
                    noBorder={true}
                    className="[&>div>button]:p-1 [&>div>input]:pl-0 [&>div>input]:text-md [&>div>input]:focus-within:outline-none [&>div>input]:focus-visible:outline-none [&>div>input]:focus:outline-none [&>div]:focus-within:ring-0 shadow-none w-full resize-none text-ellipsis border-b border-transparent hover:border-gray-300 focus:border-gray-500 focus:outline-none"
                ></Combobox.Full>
                <Button size="sm" onClick={handleTranslate} disabled={!selectedLanguage}>
                    {_t.global.translate()}
                </Button>
            </Dialog.Panel>
        </Dialog>
    );
}
